import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {}
}

const state = getDefaultState()

const mutations = {}

const actions = {
  async getCreditSummary({ commit }, params) {
    const apiResult = await apiService.post(route('member.credit-summary.get'), params)
    if (apiResult) {
      return apiResult
    }
  },
}

export default {
  state,
  mutations,
  actions,
}
